var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeslaDc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.381C23.75 19.0412 18.3809 25.4265 12.0025 29.6979C5.16984 24.9644 0.25 19.0453 0.25 12.381C0.25 5.67379 5.51796 0.25 12 0.25C18.482 0.25 23.75 5.67379 23.75 12.381Z",
    fill: "#E31937",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.75C12 6.75 7.27542 6.80235 3.75 8.3663C3.90399 8.72621 4.18576 9.31515 4.18576 9.31515C4.18576 9.31515 7.61289 7.72175 12 7.76755C16.3871 7.72175 19.8142 9.31515 19.8142 9.31515C19.8142 9.31515 20.096 8.72621 20.25 8.3663C16.7279 6.80235 12 6.75 12 6.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.3785L10.2993 8.34668C10.2993 8.34668 7.28501 8.42848 4.49023 9.76667C5.11931 10.7155 6.03998 11.1441 6.68543 11.419C6.76734 10.8922 6.93116 10.0971 9.64403 10.2182L11.9998 23.25L14.3555 10.2182C17.0684 10.0971 17.2322 10.8922 17.3141 11.419C17.9596 11.1441 18.8802 10.7155 19.5093 9.76667C16.7145 8.42848 13.7002 8.34668 13.7002 8.34668L11.9998 10.3785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaDc);
export default __webpack_public_path__ + "static/media/tesla_dc.a86b40f40a739984865f4384f6b32a58.svg";
export { ForwardRef as ReactComponent };